module.exports = __webpack_public_path__ + "static/mw2-4c24ec1eb856e2a321250c64e91e44d0.jpg";